import { render } from "./SuggestedListingProperty.vue?vue&type=template&id=71d74454"
import script from "./SuggestedListingProperty.vue?vue&type=script&lang=js"
export * from "./SuggestedListingProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__